export default __webpack_public_path__ + "static/media/audioNew.a557b3b8.svg";